// Icons used in step / time / CTA UI ---
const sunIcon = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>

<!-- License: PD. Made by paomedia: https://github.com/paomedia/small-n-flat -->
<svg width="10px" height="10px" viewBox="0 0 24 24" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/">
 <g transform="translate(0 -1028.4)">
  <g>
   <path d="m12 0l-4 4h-5v5l-3 3 3 3v6h6l3 3 3-3h6v-6l3-3-3-3v-5h-5l-4-4z" transform="translate(0 1028.4)" fill="#f39c12"/>
   <path d="m24 13c0 6.075-5.149 11-11.5 11-6.3513 0-11.5-4.925-11.5-11 0-6.0751 5.1487-11 11.5-11 6.351 0 11.5 4.9249 11.5 11z" transform="matrix(.78261 0 0 .81818 2.2174 1029.7)" fill="#f1c40f"/>
  </g>
 </g>
</svg>`;

const halfMoon = `<?xml version="1.0" encoding="utf-8"?>
<!-- License: Apache. Made by Iconscout: https://github.com/Iconscout/unicons -->
<svg fill="#000000" width="10px" height="10px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z"/></svg>`;

// ======================================================
// Routine Section Configuration
// ======================================================

const routineConfig = {
    fine_lines_wrinkles: {

        normal_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream with SPF 30",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        dry_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream with SPF 30",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        oily_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream with SPF 30",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        combination_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream with SPF 30",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        sensitive_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `1× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `1-2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Divine Elixir Ayurvedic Blend Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        mature_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream with SPF 30",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        }
    },

    loss_firmness: {

        normal_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                },
                {
                    product: "Divine Elixir Firming Algae Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        dry_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `1-2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        oily_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        combination_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        sensitive_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `1-2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Divine Elixir Ayurvedic Blend Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        mature_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                },
                {
                    product: "Divine Elixir Firming Algae Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}, Weekly`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        }
    },

    congestion_breakouts: {

        normal_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `1-2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Divine Elixir Firming Algae Facial Oil",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}, Weekly`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        dry_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `1× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Divine Elixir Firming Algae Facial Oil",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}, Weekly`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        oily_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `1-2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        combination_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `1-2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Divine Elixir Firming Algae Facial Oil",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}, Weekly`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        sensitive_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `1× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `1-2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        mature_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                },
                {
                    product: "Divine Elixir Firming Algae Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}, Weekly`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream with SPF 30",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        }
    },

    hormonal_concerns: {

        normal_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        dry_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Divine Elixir Ayurvedic Blend Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        oily_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        combination_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Ayurvedic Blend Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        sensitive_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `1× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `1× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Divine Elixir Ayurvedic Blend Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        mature_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream with SPF 30",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        }
    },

    hyperpigmentation: {

        normal_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `Weekly`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        dry_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `Every Other Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `1× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        oily_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `Weekly`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        combination_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `Weekly`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        sensitive_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon} Daily`,
                    bgColor: "#D5E7D2"
                },
                {
                    product: "Divine Elixir Ayurvedic Blend Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        mature_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `Weekly`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        }
    },

    dryness: {

        normal_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Age Reset Advanced Night Cream with Tri-Retinol",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        dry_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                },
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }, {
                    product: "Divine Elixir Luminous Facial Oil with SWT-7 Technology",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        oily_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }
            ]
        },


        combination_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                },
                {
                    product: "Divine Elixir Luminous Facial Oil with SWT-7 Technology",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        sensitive_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `Daily`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Divine Elixir Ayurvedic Blend Facial Oil",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        mature_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Divine Elixir Vitamin C Serum",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Age Reset Restore + Protect Day Cream with SPF 30",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        }
    },

    milia: {

        normal_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `Alternating Nights`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        dry_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2-3× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        oily_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, Alternating Nights`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        combination_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        sensitive_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `2-3× Week, PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        mature_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "DermAppeal Daily",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, Alternating Nights`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                },
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                },
                {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        }
    },

    sebaceous_fil: {

        normal_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, Ongoing Maintenance`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        dry_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2× Week`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Divine Elixir Luminous Firming Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        oily_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "DermAppeal Daily",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, Full Frequency / Primary Maintenance`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        combination_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 2-3× Week, T-zone Focused`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM`,
                    bgColor: "#D4EAED"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        },


        sensitive_skin: {

            section_cleanser: [
                {
                    product: "Olive + Enzyme Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                }, {
                    product: "Olive + Enzyme Makeup Removing Cleansing Cloths",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Daily",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Weekly`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1× Week, Patch Test`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ],

            section_cream: [
                {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }
            ]
        },


        mature_skin: {

            section_cleanser: [
                {
                    product: "Green Tea + Mint Cleanser",
                    step: "Step 1 • Cleanser",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "DermAppeal Daily",
                    step: "Step 1 • Cleanser",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_exfoliation: [
                {
                    product: "DermAppeal Microdermabrasion Treatment",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, 1-2× Week`,
                    bgColor: "#D4EAED"
                },
                {
                    product: "Multi-Acid Resurfacing Pads",
                    step: "Step 2 • Exfoliation",
                    timing: `PM ${halfMoon}, Alternating Nights`,
                    bgColor: "#D4EAED"
                }
            ],

            section_treatment_serum: [
                {
                    product: "Mantle Milk",
                    step: "Step 3 • Treatment / Serum",
                    timing: `${sunIcon} AM / PM ${halfMoon}`,
                    bgColor: "#D5E7D2"
                }, {
                    product: "Age Reset Serum Intensive",
                    step: "Step 3 • Treatment / Serum",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ],

            section_cream: [
                {
                    product: "Restore + Protect Day Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `${sunIcon} AM`,
                    bgColor: "#FFF7A5"
                },
                {
                    product: "Hydrating Algae Gel Cream",
                    step: "Step 4 • Moisturizer",
                    timing: `PM ${halfMoon}`,
                    bgColor: "#D4EAED"
                }
            ]
        }
    },
};

const textureConfig = {
    texture_smooth: {
        section_cleanser: null,
        section_exfoliation: null,
        suggested_add: []
    },

    texture_rough: {
        section_cleanser: [
            {
                product: "Olive + Enzyme Cleanser",
                step: "Step 1 • Cleanser",
                timing: `${sunIcon} AM / PM ${halfMoon}`,
                bgColor: "#D5E7D2"
            }
        ],

        section_exfoliation: [
            {
                product: "DermAppeal Daily",
                step: "Step 2 • Exfoliation",
                timing: "Daily",
                bgColor: "#D4EAED"
            }
        ],

        suggested_add: [
            "Divine Elixir Ayurvedic Blend Facial Oil",
            "Divine Elixir Luminous Firming Cream"
        ]
    },

    texture_pores: {
        section_cleanser: [
            {
                product: "Green Tea + Mint Cleanser",
                step: "Step 1 • Cleanser",
                timing: `${sunIcon} AM / PM ${halfMoon}`,
                bgColor: "#D5E7D2"
            }
        ],

        section_exfoliation: [
            {
                product: "DermAppeal® Microdermabrasion Treatment",
                step: "Step 2 • Exfoliation",
                timing: "2× Week",
                bgColor: "#D4EAED"
            }
        ],

        suggested_add: [
            "Divine Elixir Hydrating Algae Gel Cream"
        ]
    },

    texture_milia_sf: {
        section_cleanser: [
            {
                product: "Green Tea + Mint Cleanser",
                step: "Step 1 • Cleanser",
                timing: `${sunIcon} AM / PM ${halfMoon}`,
                bgColor: "#D5E7D2"
            }
        ],

        section_exfoliation: [
            {
                product: "DermAppeal® Microdermabrasion Treatment",
                step: "Step 2 • Exfoliation",
                timing: "2× Week",
                bgColor: "#D4EAED"
            }
        ],

        suggested_add: [
            "Age Reset Serum Intensive",
            "Divine Elixir Hydrating Algae Gel Cream"
        ]
    },

    texture_dull: {
        section_cleanser: [
            {
                product: "Green Tea + Mint Cleanser",
                step: "Step 1 • Cleanser",
                timing: `${sunIcon} AM`,
                bgColor: "#FFF7A5"
            },
            {
                product: "Olive + Enzyme Cleanser",
                step: "Step 1 • Cleanser",
                timing: `PM ${halfMoon}`,
                bgColor: "#D4EAED"
            }
        ],

        section_exfoliation: [
            {
                product: "DermAppeal Daily",
                step: "Step 2 • Exfoliation",
                timing: "Daily",
                bgColor: "#D4EAED"
            }
        ],

        suggested_add: [
            "Divine Elixir Luminous Facial Oil with SWT-7 Technology",
            "Age Reset Serum Intensive"
        ]
    }
};


function getConcern(tags) {
    return Object.keys(routineConfig).find(key => tags.includes(key));
}

function getSkinType(tags) {
    const skinTypes = [
        "normal_skin",
        "dry_skin",
        "oily_skin",
        "combination_skin",
        "sensitive_skin",
        "mature_skin"
    ];

    return skinTypes.find(type => tags.includes(type));
}

function getTextureType(tags) {
    const textureTypes = [
        "texture_smooth",
        "texture_rough",
        "texture_pores",
        "texture_milia_sf",
        "texture_dull"
    ];

    return textureTypes.find(type => tags.includes(type));
}


function getTextureOverride(textureType, sectionKey) {
    if (!textureType) return null;

    return textureConfig?.[textureType]?.[sectionKey] || null;
}


function normalizeTitle(title) {
    return String(title || "")
        .toLowerCase()
        .replace(/[®™]/g, "")
        .replace(/\([^)]*\)/g, "")
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

function getRoutineItem(concern, skinType, sectionKey, productTitle) {
    const section = routineConfig?.[concern]?.[skinType]?.[sectionKey];

    if (!section) return null;

    const normalizedProduct = normalizeTitle(productTitle);

    return section.find(item => {
        const normalizedConfig = normalizeTitle(item.product);

        return (
            normalizedProduct === normalizedConfig ||
            normalizedProduct.includes(normalizedConfig) ||
            normalizedConfig.includes(normalizedProduct)
        );
    });
}

function getRoutineConfigItem(
    concern,
    skinType,
    textureType,
    sectionKey,
    productTitle
) {
    // Texture override ONLY for cleanser/exfoliation
    if (
        textureType &&
        (sectionKey === "section_cleanser" ||
            sectionKey === "section_exfoliation")
    ) {
        const textureSection = getTextureOverride(
            textureType,
            sectionKey
        );

        if (textureSection) {
            const normalizedProduct = normalizeTitle(productTitle);

            const textureItem = textureSection.find(item => {
                const normalizedConfig = normalizeTitle(item.product);

                return (
                    normalizedProduct === normalizedConfig ||
                    normalizedProduct.includes(normalizedConfig) ||
                    normalizedConfig.includes(normalizedProduct)
                );
            });

            return textureItem || null;
        }
    }

    // Everything else continues using old routineConfig
    return getRoutineItem(
        concern,
        skinType,
        sectionKey,
        productTitle
    );
}